/** @format */

import Vue from 'vue';
import Vuex from 'vuex';
import * as notification from '@/store/modules/notification.js';
import * as user from '@/store/modules/user.js';
import * as validation from '@/store/modules/validation.js';
import * as courses from '@/store/modules/courses.js';
import * as rounds from '@/store/modules/rounds.js';
import * as shots from '@/store/modules/shots.js';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		notification,
		user,
		validation,
		courses,
		rounds,
		shots
	},
});
